// packages/components/src/view/component.tsx
import { forwardRef } from "@wordpress/element";
import { PolymorphicElement } from "../utils/polymorphic-element.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
function UnforwardedView({
  css,
  ...restProps
}, ref) {
  void css;
  return /* @__PURE__ */ _jsx(PolymorphicElement, {
    ref,
    ...restProps
  });
}
var View = Object.assign(forwardRef(UnforwardedView), {
  selector: ".components-view"
});
var component_default = View;
export {
  View,
  component_default as default
};
//# sourceMappingURL=component.mjs.map
